(function() {
    var __webpack_require__ = {};
    !function() {
        __webpack_require__.r = function(exports) {
            if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
                Object.defineProperty(exports, Symbol.toStringTag, {
                    value: "Module"
                });
            }
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
        };
    }();
    var __webpack_exports__ = {};
    !function() {
        (() => {
            if (window.erk_shop_the_look) return;
            window.erk_shop_the_look = true;
            function initRoot(root) {
                if (!root || root.dataset.elstInit) return;
                root.dataset.elstInit = "1";
                const panels = root.querySelectorAll(".elst__panel");
                const tabsBar = root.querySelector(".elst__tabs");
                const tabsWrap = root.querySelector(".elst__tabs-wrap");
                const prevArrow = root.querySelector("[data-elst-prev]");
                const nextArrow = root.querySelector("[data-elst-next]");
                function switchTab(index) {
                    panels.forEach(((panel, i) => {
                        panel.classList.toggle("elst__panel--active", i === index);
                    }));
                    if (tabsBar) {
                        tabsBar.querySelectorAll(".elst__tab").forEach(((tab, i) => {
                            tab.classList.toggle("elst__tab--active", i === index);
                            tab.setAttribute("aria-selected", i === index ? "true" : "false");
                        }));
                    }
                    const activeTab = tabsBar && tabsBar.querySelector(".elst__tab--active");
                    if (activeTab && typeof activeTab.scrollIntoView === "function") {
                        activeTab.scrollIntoView({
                            block: "nearest",
                            inline: "nearest",
                            behavior: "smooth"
                        });
                    }
                }
                if (tabsBar) {
                    tabsBar.addEventListener("click", (e => {
                        const tab = e.target.closest("[data-elst-tab]");
                        if (!tab) return;
                        switchTab(parseInt(tab.getAttribute("data-elst-tab"), 10) || 0);
                    }));
                }
                function updateArrows() {
                    if (!tabsWrap || !prevArrow || !nextArrow) return;
                    const overflow = tabsWrap.scrollWidth > tabsWrap.clientWidth + 1;
                    const maxScroll = tabsWrap.scrollWidth - tabsWrap.clientWidth;
                    prevArrow.disabled = !overflow || tabsWrap.scrollLeft <= 1;
                    nextArrow.disabled = !overflow || tabsWrap.scrollLeft >= maxScroll - 1;
                }
                if (tabsWrap && prevArrow && nextArrow) {
                    prevArrow.addEventListener("click", (() => tabsWrap.scrollBy({
                        left: -240,
                        behavior: "smooth"
                    })));
                    nextArrow.addEventListener("click", (() => tabsWrap.scrollBy({
                        left: 240,
                        behavior: "smooth"
                    })));
                    tabsWrap.addEventListener("scroll", updateArrows, {
                        passive: true
                    });
                    window.addEventListener("resize", updateArrows);
                    updateArrows();
                }
            }
            function initAll(scope) {
                (scope || document).querySelectorAll(".erk-shop-lst[data-elst]").forEach(initRoot);
            }
            if (document.readyState === "loading") {
                document.addEventListener("DOMContentLoaded", (() => initAll(document)));
            } else {
                initAll(document);
            }
            document.addEventListener("shopify:section:load", (e => initAll(e.target)));
        })();
    }();
    !function() {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
    }();
})();